import React from 'react';

import MarkedAnchorItem from '../MarkedAnchorItem/MarkedAnchorItem';

const MarkedAcitivityItem = (props) => {
  const { activity, linkSubject, onClickFile } = props;
  const activityArr = activity.split(' ');
  const action = activityArr[0].toLowerCase();
  const actionTypeLabel = 'as ' + activityArr[activityArr.length - 1].toLowerCase();

  return (
    <MarkedAnchorItem
      action={action}
      subject={linkSubject}
      actionTypeLabel={actionTypeLabel}
      onClickFile={onClickFile}
    />
  );
};

export default MarkedAcitivityItem;
